import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.set-prototype-of";
import "core-js/modules/es6.function.name";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

import PropTypes from 'prop-types';
import React from 'react';
import { Text, Clipboard, StyleSheet, TouchableWithoutFeedback, View, ViewPropTypes } from 'react-native';
import QuickReplies from './QuickReplies';
import MessageText from './MessageText';
import MessageImage from './MessageImage';
import MessageVideo from './MessageVideo';
import Time from './Time';
import Color from './Color';
import { isSameUser, isSameDay } from './utils';
var styles = {
  left: StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'flex-start'
    },
    wrapper: {
      borderRadius: 15,
      backgroundColor: Color.leftBubbleBackground,
      marginRight: 60,
      minHeight: 20,
      justifyContent: 'flex-end'
    },
    containerToNext: {
      borderBottomLeftRadius: 3
    },
    containerToPrevious: {
      borderTopLeftRadius: 3
    },
    bottom: {
      flexDirection: 'row',
      justifyContent: 'flex-start'
    }
  }),
  right: StyleSheet.create({
    container: {
      flex: 1,
      alignItems: 'flex-end'
    },
    wrapper: {
      borderRadius: 15,
      backgroundColor: Color.defaultBlue,
      marginLeft: 60,
      minHeight: 20,
      justifyContent: 'flex-end'
    },
    containerToNext: {
      borderBottomRightRadius: 3
    },
    containerToPrevious: {
      borderTopRightRadius: 3
    },
    bottom: {
      flexDirection: 'row',
      justifyContent: 'flex-end'
    }
  }),
  content: StyleSheet.create({
    tick: {
      fontSize: 10,
      backgroundColor: Color.backgroundTransparent,
      color: Color.white
    },
    tickView: {
      flexDirection: 'row',
      marginRight: 10
    },
    username: {
      top: -3,
      left: 0,
      fontSize: 12,
      backgroundColor: 'transparent',
      color: '#aaa'
    },
    usernameView: {
      flexDirection: 'row',
      marginHorizontal: 10
    }
  })
};
var DEFAULT_OPTION_TITLES = ['Copy Text', 'Cancel'];

var Bubble =
/*#__PURE__*/
function (_React$Component) {
  _inherits(Bubble, _React$Component);

  function Bubble() {
    var _this;

    _classCallCheck(this, Bubble);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Bubble).apply(this, arguments));

    _this.onLongPress = function () {
      var currentMessage = _this.props.currentMessage;

      if (_this.props.onLongPress) {
        _this.props.onLongPress(_this.context, _this.props.currentMessage);
      } else if (currentMessage && currentMessage.text) {
        var optionTitles = _this.props.optionTitles;
        var options = optionTitles && optionTitles.length > 0 ? optionTitles.slice(0, 2) : DEFAULT_OPTION_TITLES;
        var cancelButtonIndex = options.length - 1;

        _this.context.actionSheet().showActionSheetWithOptions({
          options: options,
          cancelButtonIndex: cancelButtonIndex
        }, function (buttonIndex) {
          switch (buttonIndex) {
            case 0:
              Clipboard.setString(currentMessage.text);
              break;

            default:
              break;
          }
        });
      }
    };

    return _this;
  }

  _createClass(Bubble, [{
    key: "styledBubbleToNext",
    value: function styledBubbleToNext() {
      var _this$props = this.props,
          currentMessage = _this$props.currentMessage,
          nextMessage = _this$props.nextMessage,
          position = _this$props.position,
          containerToNextStyle = _this$props.containerToNextStyle;

      if (currentMessage && nextMessage && position && isSameUser(currentMessage, nextMessage) && isSameDay(currentMessage, nextMessage)) {
        return [styles[position].containerToNext, containerToNextStyle && containerToNextStyle[position]];
      }

      return null;
    }
  }, {
    key: "styledBubbleToPrevious",
    value: function styledBubbleToPrevious() {
      var _this$props2 = this.props,
          currentMessage = _this$props2.currentMessage,
          previousMessage = _this$props2.previousMessage,
          position = _this$props2.position,
          containerToPreviousStyle = _this$props2.containerToPreviousStyle;

      if (currentMessage && previousMessage && position && isSameUser(currentMessage, previousMessage) && isSameDay(currentMessage, previousMessage)) {
        return [styles[position].containerToPrevious, containerToPreviousStyle && containerToPreviousStyle[position]];
      }

      return null;
    }
  }, {
    key: "renderQuickReplies",
    value: function renderQuickReplies() {
      var _this$props3 = this.props,
          currentMessage = _this$props3.currentMessage,
          onQuickReply = _this$props3.onQuickReply,
          nextMessage = _this$props3.nextMessage,
          renderQuickReplySend = _this$props3.renderQuickReplySend,
          quickReplyStyle = _this$props3.quickReplyStyle;

      if (currentMessage && currentMessage.quickReplies) {
        var _this$props4 = this.props,
            containerStyle = _this$props4.containerStyle,
            wrapperStyle = _this$props4.wrapperStyle,
            quickReplyProps = _objectWithoutProperties(_this$props4, ["containerStyle", "wrapperStyle"]);

        if (this.props.renderQuickReplies) {
          return this.props.renderQuickReplies(quickReplyProps);
        }

        return React.createElement(QuickReplies, {
          currentMessage: currentMessage,
          onQuickReply: onQuickReply,
          nextMessage: nextMessage,
          renderQuickReplySend: renderQuickReplySend,
          quickReplyStyle: quickReplyStyle
        });
      }

      return null;
    }
  }, {
    key: "renderMessageText",
    value: function renderMessageText() {
      if (this.props.currentMessage && this.props.currentMessage.text) {
        var _this$props5 = this.props,
            containerStyle = _this$props5.containerStyle,
            wrapperStyle = _this$props5.wrapperStyle,
            messageTextProps = _objectWithoutProperties(_this$props5, ["containerStyle", "wrapperStyle"]);

        if (this.props.renderMessageText) {
          return this.props.renderMessageText(messageTextProps);
        }

        return React.createElement(MessageText, messageTextProps);
      }

      return null;
    }
  }, {
    key: "renderMessageImage",
    value: function renderMessageImage() {
      if (this.props.currentMessage && this.props.currentMessage.image) {
        var _this$props6 = this.props,
            containerStyle = _this$props6.containerStyle,
            wrapperStyle = _this$props6.wrapperStyle,
            messageImageProps = _objectWithoutProperties(_this$props6, ["containerStyle", "wrapperStyle"]);

        if (this.props.renderMessageImage) {
          return this.props.renderMessageImage(messageImageProps);
        }

        return React.createElement(MessageImage, messageImageProps);
      }

      return null;
    }
  }, {
    key: "renderMessageVideo",
    value: function renderMessageVideo() {
      if (this.props.currentMessage && this.props.currentMessage.video) {
        var _this$props7 = this.props,
            containerStyle = _this$props7.containerStyle,
            wrapperStyle = _this$props7.wrapperStyle,
            messageVideoProps = _objectWithoutProperties(_this$props7, ["containerStyle", "wrapperStyle"]);

        if (this.props.renderMessageVideo) {
          return this.props.renderMessageVideo(messageVideoProps);
        }

        return React.createElement(MessageVideo, messageVideoProps);
      }

      return null;
    }
  }, {
    key: "renderTicks",
    value: function renderTicks() {
      var _this$props8 = this.props,
          currentMessage = _this$props8.currentMessage,
          renderTicks = _this$props8.renderTicks,
          user = _this$props8.user;

      if (renderTicks && currentMessage) {
        return renderTicks(currentMessage);
      }

      if (currentMessage && user && currentMessage.user._id !== user._id) {
        return null;
      }

      if (currentMessage && (currentMessage.sent || currentMessage.received || currentMessage.pending)) {
        return React.createElement(View, {
          style: styles.content.tickView
        }, !!currentMessage.sent && React.createElement(Text, {
          style: [styles.content.tick, this.props.tickStyle]
        }, "\u2713"), !!currentMessage.received && React.createElement(Text, {
          style: [styles.content.tick, this.props.tickStyle]
        }, "\u2713"), !!currentMessage.pending && React.createElement(Text, {
          style: [styles.content.tick, this.props.tickStyle]
        }, "\uD83D\uDD53"));
      }

      return null;
    }
  }, {
    key: "renderTime",
    value: function renderTime() {
      if (this.props.currentMessage && this.props.currentMessage.createdAt) {
        var _this$props9 = this.props,
            containerStyle = _this$props9.containerStyle,
            wrapperStyle = _this$props9.wrapperStyle,
            textStyle = _this$props9.textStyle,
            timeProps = _objectWithoutProperties(_this$props9, ["containerStyle", "wrapperStyle", "textStyle"]);

        if (this.props.renderTime) {
          return this.props.renderTime(timeProps);
        }

        return React.createElement(Time, timeProps);
      }

      return null;
    }
  }, {
    key: "renderUsername",
    value: function renderUsername() {
      var _this$props10 = this.props,
          currentMessage = _this$props10.currentMessage,
          user = _this$props10.user;

      if (this.props.renderUsernameOnMessage && currentMessage) {
        if (user && currentMessage.user._id === user._id) {
          return null;
        }

        return React.createElement(View, {
          style: styles.content.usernameView
        }, React.createElement(Text, {
          style: [styles.content.username, this.props.usernameStyle]
        }, "~ ", currentMessage.user.name));
      }

      return null;
    }
  }, {
    key: "renderCustomView",
    value: function renderCustomView() {
      if (this.props.renderCustomView) {
        return this.props.renderCustomView(this.props);
      }

      return null;
    }
  }, {
    key: "renderBubbleContent",
    value: function renderBubbleContent() {
      return this.props.isCustomViewBottom ? React.createElement(View, null, this.renderMessageImage(), this.renderMessageVideo(), this.renderMessageText(), this.renderCustomView()) : React.createElement(View, null, this.renderCustomView(), this.renderMessageImage(), this.renderMessageVideo(), this.renderMessageText());
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props11 = this.props,
          position = _this$props11.position,
          containerStyle = _this$props11.containerStyle,
          wrapperStyle = _this$props11.wrapperStyle,
          bottomContainerStyle = _this$props11.bottomContainerStyle;
      return React.createElement(View, {
        style: [styles[position].container, containerStyle && containerStyle[position]]
      }, React.createElement(View, {
        style: [styles[position].wrapper, wrapperStyle && wrapperStyle[position], this.styledBubbleToNext(), this.styledBubbleToPrevious()]
      }, React.createElement(TouchableWithoutFeedback, _extends({
        onLongPress: this.onLongPress,
        accessibilityTraits: "text"
      }, this.props.touchableProps), React.createElement(View, null, this.renderBubbleContent(), React.createElement(View, {
        style: [styles[position].bottom, bottomContainerStyle && bottomContainerStyle[position]]
      }, this.renderUsername(), this.renderTime(), this.renderTicks())))), this.renderQuickReplies());
    }
  }]);

  return Bubble;
}(React.Component);

export { Bubble as default };
Bubble.contextTypes = {
  actionSheet: PropTypes.func
};
Bubble.defaultProps = {
  touchableProps: {},
  onLongPress: null,
  renderMessageImage: null,
  renderMessageVideo: null,
  renderMessageText: null,
  renderCustomView: null,
  renderUsername: null,
  renderTicks: null,
  renderTime: null,
  renderQuickReplies: null,
  onQuickReply: null,
  position: 'left',
  optionTitles: DEFAULT_OPTION_TITLES,
  currentMessage: {
    text: null,
    createdAt: null,
    image: null
  },
  nextMessage: {},
  previousMessage: {},
  containerStyle: {},
  wrapperStyle: {},
  bottomContainerStyle: {},
  tickStyle: {},
  usernameStyle: {},
  containerToNextStyle: {},
  containerToPreviousStyle: {}
};
Bubble.propTypes = {
  user: PropTypes.object.isRequired,
  touchableProps: PropTypes.object,
  onLongPress: PropTypes.func,
  renderMessageImage: PropTypes.func,
  renderMessageVideo: PropTypes.func,
  renderMessageText: PropTypes.func,
  renderCustomView: PropTypes.func,
  isCustomViewBottom: PropTypes.bool,
  renderUsernameOnMessage: PropTypes.bool,
  renderUsername: PropTypes.func,
  renderTime: PropTypes.func,
  renderTicks: PropTypes.func,
  renderQuickReplies: PropTypes.func,
  onQuickReply: PropTypes.func,
  position: PropTypes.oneOf(['left', 'right']),
  optionTitles: PropTypes.arrayOf(PropTypes.string),
  currentMessage: PropTypes.object,
  nextMessage: PropTypes.object,
  previousMessage: PropTypes.object,
  containerStyle: PropTypes.shape({
    left: ViewPropTypes.style,
    right: ViewPropTypes.style
  }),
  wrapperStyle: PropTypes.shape({
    left: ViewPropTypes.style,
    right: ViewPropTypes.style
  }),
  bottomContainerStyle: PropTypes.shape({
    left: ViewPropTypes.style,
    right: ViewPropTypes.style
  }),
  tickStyle: PropTypes.any,
  usernameStyle: PropTypes.any,
  containerToNextStyle: PropTypes.shape({
    left: ViewPropTypes.style,
    right: ViewPropTypes.style
  }),
  containerToPreviousStyle: PropTypes.shape({
    left: ViewPropTypes.style,
    right: ViewPropTypes.style
  })
};